import  api  from './api';

export const getStatusList = async (codeType) => {
    let statusList = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        statusList = response.data.data;
    } catch (err) {}
    return statusList;
}

export const getStatus = async (codeType) => {
    let status = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        status = response.data.data;
    } catch (err) {}
    return status;
}